const set = {
	setColors: "preferences/colors/setColors",
};

const constants = Object.seal(set);
export default constants;
